import _ from 'lodash';
import BackgroundImage from '~/components/sanity/BackgroundImage.vue';
import SanityBlockContent from '~/components/sanity/SanityBlockContent.vue';
import Container from '~/components/sanity/Container.vue';
import CtaBtn from '~/components/sanity/CtaBtn.vue';
export default {
  name: 'CtaSection',
  components: {
    Container,
    CtaBtn,
    SanityBlockContent,
    BackgroundImage
  },
  props: {
    content: Object,
    styles: Object
  },
  data() {
    return {
      heading: this.content.heading || null,
      cta: this.content.cta || null,
      caption: this.content.caption || null
    };
  },
  computed: {
    existingParams() {
      if (!this.$route.query) return null;
      return Object.keys(this.$route.query).map(key => {
        return `${key}=${this.$route.query[key]}`;
      }).join('&') || null;
    },
    showBgImg() {
      if (!this.styles) return false;
      const {
        backgroundImage
      } = this.styles;
      return !_.isUndefined(backgroundImage);
    },
    style() {
      if (!this.styles) return;
      const {
        color,
        backgroundColor
      } = this.styles;
      const style = {
        ...(color && {
          color
        }),
        ...(backgroundColor && {
          backgroundColor
        })
      };
      return style;
    }
  }
};